module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d24599d9a1ea52c40c13a71d8ac26523.gif";